import { IComponentOptions } from "angular";
import { UserProfileApiKeyPageController } from "./controller";

export const vsComponentName = "userProfileApiKeyPage";

export const userProfileApiKeyPageComponentOptions: IComponentOptions = {
  controller: UserProfileApiKeyPageController,
  template: require("!html-loader!./index.html").default,
  controllerAs: "apiKeyPageController",
};
